var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-[#f8f9fc] sticky-footer"},[_c('div',{staticClass:"container my-auto akkurate-small"},[_c('div',{staticClass:"text-center my-auto copyright"},[_c('span',[_vm._v("Copyright © Akkurate 2024")])])])])
}]

export { render, staticRenderFns }